import { useCallback } from 'react';
import { buildColMeta, useTableSearch } from '@/components/custom/erp/data-table-v2';
import type { SearchValues } from '@/components/custom/erp/data-table-v2';
import type { DoiTuongSearchParams } from '@/types/schemas';
import { MAIN_COLUMNS } from '../cols-definition';
import { QUERY_KEYS } from '@/constants';

interface UseSearchTableProps {
  searchData: (filters: DoiTuongSearchParams, page?: number, searchPageSize?: number) => Promise<void>;
  searchParams?: DoiTuongSearchParams;
  setSearchParams?: (params: DoiTuongSearchParams) => void;
  isFiltered: boolean;
  handlePageChange: (page: number) => Promise<void>;
}

export const useSearchTable = ({
  searchData,
  searchParams = {},
  setSearchParams = () => {},
  isFiltered,
  handlePageChange
}: UseSearchTableProps) => {
  const getColumnMeta = useCallback(() => buildColMeta(MAIN_COLUMNS), []);

  const {
    searchState,
    handleSearchChange,
    onPageChange,
    hasFilterParams,
    handleInitialSearch,
    handleRefreshClick,
    isFiltering
  } = useTableSearch<DoiTuongSearchParams>({
    endpoint: `${QUERY_KEYS.KHACH_HANG}/filter`,
    pageSize: 100,
    searchData,
    searchParams,
    setSearchParams,
    isFiltered,
    handlePageChange,
    getColumnMeta
  });

  return {
    searchState,
    handleSearchChange: handleSearchChange as (values: SearchValues) => void,
    onPageChange,
    hasFilterParams,
    handleInitialSearch,
    handleRefreshClick,
    isFiltering
  };
};
